import React from "react";
import "../../../../../assets/styles/main.css";
import "../../../../../assets/styles/responsive.css";

const TermsAndConditionContent = () => {
  return (
    <div className="terms-and-conditions">
      <div className="container">
        <p className="date">Last Updated: December 5, 2024</p>

        <h3>1. Overview</h3>
        <p>
          Welcome to <strong>LeadBud LLC</strong> ("LeadBud", "we", "us", or
          "our"). These Terms and Conditions ("Terms") govern your access to
          and use of our platform, services, and tools, including our website
          (<a href="https://leadbud.io">leadbud.io</a>) and related
          applications. By accessing or using our Services, you agree to comply
          with and be bound by these Terms. If you do not agree, you must not
          use our platform.
        </p>

        <h3>2. Our Details</h3>
        <p>
          <strong>Business Name:</strong> LeadBud LLC
          <br />
          <strong>Address:</strong> [Your Business Address], United States
          <br />
          <strong>Website:</strong> <a href="https://leadbud.io">leadbud.io</a>
          <br />
          <strong>Email:</strong>{" "}
          <a href="mailto:info@leadbud.io">info@leadbud.io</a>
        </p>

        <h3>3. Platform Eligibility</h3>
        <p>
          To use the LeadBud platform, you must be at least 18 years old or the
          age of majority in your jurisdiction. By using LeadBud, you
          represent and warrant that you meet these eligibility requirements.
        </p>

        <h3>4. LeadBud Services</h3>
        <ul>
          <li>
            <strong>Lead Generation:</strong> Tools for finding potential leads
            tailored to your business.
          </li>
          <li>
            <strong>Email Verification:</strong> Verifies email addresses for
            accurate and effective outreach.
          </li>
          <li>
            <strong>CRM:</strong> A customer relationship management system to
            manage and nurture leads.
          </li>
          <li>
            <strong>Email Warmup:</strong> Improves email deliverability by
            ensuring campaigns avoid spam filters.
          </li>
          <li>
            <strong>Zero Code Bots:</strong> Pre-built bots for automated data
            retrieval and monitoring.
          </li>
          <li>
            <strong>Custom Bots:</strong> Fully customized bots tailored to
            your business needs, including bots created by third-party
            developers.
          </li>
        </ul>

        <h3>5. User Accounts</h3>
        <p>
          Users must create an account to access certain features of LeadBud.
          Account holders agree to:
        </p>
        <ul>
          <li>Provide accurate and complete registration information.</li>
          <li>Maintain the confidentiality of their login credentials.</li>
          <li>
            Immediately notify LeadBud of unauthorized use of their account or
            security breaches.
          </li>
        </ul>

        <h3>6. Credits and Pricing</h3>
        <p>
          LeadBud operates on a credit-based system for accessing bots and
          services. Credits can be purchased via Paddle, our payment processor.
          Pricing and subscription plans are listed on our website. Credits are
          non-refundable, non-transferable, and may expire as outlined in your
          account settings.
        </p>

        <h3>7. Custom Bots</h3>
        <p>
          LeadBud allows third-party developers to create and share custom bots
          on the platform. LeadBud is not responsible for the functionality or
          legality of bots created by external developers. Users are encouraged
          to review the functionality of any custom bots before use.
        </p>

        <h3>8. User Responsibilities</h3>
        <p>Users agree to:</p>
        <ul>
          <li>Use the platform in compliance with all applicable laws.</li>
          <li>
            Refrain from activities that harm LeadBud, other users, or third
            parties.
          </li>
          <li>
            Ensure they have the right to process or store data accessed
            through the platform.
          </li>
        </ul>

        <h3>9. Prohibited Activities</h3>
        <p>
          The following activities are strictly prohibited:
        </p>
        <ul>
          <li>Scraping or extracting data in violation of third-party terms.</li>
          <li>Sending spam or engaging in phishing activities.</li>
          <li>Reverse engineering LeadBud’s platform or tools.</li>
          <li>
            Using LeadBud for illegal activities, including fraud or identity
            theft.
          </li>
        </ul>

        <h3>10. Payment Terms</h3>
        <p>
          Payments are securely processed by Paddle. Users must provide valid
          payment information to access paid features. Subscription payments
          will be automatically renewed unless canceled before the end of the
          billing cycle.
        </p>

        <h3>11. Data Compliance</h3>
        <p>
          Users are responsible for ensuring that their use of LeadBud complies
          with applicable data protection laws, including GDPR and CCPA. LeadBud
          provides tools to facilitate compliance but does not assume liability
          for misuse of data by users.
        </p>

        <h3>12. Intellectual Property</h3>
        <p>
          All content and tools provided by LeadBud, including custom bots, are
          the intellectual property of LeadBud or its licensors. Unauthorized
          use or reproduction is prohibited.
        </p>

        <h3>13. Limitation of Liability</h3>
        <p>
          LeadBud provides its platform "as is" and disclaims all warranties.
          We are not liable for:
        </p>
        <ul>
          <li>
            Errors or inaccuracies in data accessed through the platform.
          </li>
          <li>Damages resulting from unauthorized access to user accounts.</li>
          <li>Losses due to user misuse of the platform or tools.</li>
        </ul>

        <h3>14. Termination</h3>
        <p>
          LeadBud may suspend or terminate user accounts for violating these
          terms or engaging in activities harmful to the platform.
        </p>

        <h3>15. Governing Law</h3>
        <p>
          These Terms are governed by the laws of the State of Delaware, United
          States, without regard to conflict of law principles.
        </p>

        <h3>16. Changes to Terms</h3>
        <p>
          LeadBud reserves the right to update these Terms. Changes will be
          communicated via email or platform notifications.
        </p>

        <h3>17. Contact Information</h3>
        <p>
          For questions or concerns, contact us at:
        </p>
        <p>
          <strong>Email:</strong>{" "}
          <a href="mailto:info@leadbud.io">info@leadbud.io</a>
        </p>
        <p>
          <strong>Address:</strong> LeadBud LLC, [Your Business Address], United
          States
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditionContent;
